const createBdiChoices = (statements) =>
  statements.map((text, index) => ({
    value: index,
    text: `${index}. ${text}`,
  }));

const createBdiQuestion = (number, statements) => ({
  type: "radiogroup",
  name: `bdi_${number}`,
  title: `${number}.`,
  isRequired: true,
  colCount: 1,
  choices: createBdiChoices(statements),
});

const createMatrixRows = (items) =>
  items.map((text, index) => ({
    value: `item_${index + 1}`,
    text,
  }));

const createMatrixQuestion = ({
  name,
  title,
  description,
  columns,
  rows,
  rowTitleWidth = "70%",
}) => ({
  type: "matrix",
  name,
  title,
  description,
  isRequired: true,
  isAllRowRequired: true,
  alternateRows: true,
  rowTitleWidth,
  columns,
  rows: createMatrixRows(rows),
});

const bdiItems = [
  [
    "Nem vagyok szomorú.",
    "Szomorú vagy nyomott vagyok.",
    "Mindig szomorú vagyok és nem tudok kikeveredni belőle.",
    "Annyira szomorú és boldogtalan vagyok, hogy nem bírom tovább.",
  ],
  [
    "Nem félek különösebben a jövőt illetően.",
    "Félek a jövőtől.",
    "Úgy érzem semmit sem várhatok a jövőtől.",
    "Úgy látom, hogy a jövő reménytelen és a helyzetem nem fog javulni.",
  ],
  [
    "Nem érzem, hogy kudarcot vallottam.",
    "Úgy érzem, több kudarc ér, mint másokat.",
    "Visszatekintve életemre, kudarcok sorozatát látom.",
    "Úgy érzem, mint ember teljesen kudarcot vallottam.",
  ],
  [
    "A dolgok ugyanolyan megelégedettséggel töltenek el mint máskor.",
    "A dolgokkal nem vagyok úgy megelégedve mint máskor.",
    "Valójában többé semmi nem okoz elégedettséget nekem.",
    "Mindennel elégedetlen vagy közömbös vagyok.",
  ],
  [
    "Nem hibáztatom különösebben magam.",
    "Gyakran hibáztatom magam.",
    "Majdnem mindig hibáztatom magam valami miatt.",
    "Állandóan hibáztatom magam.",
  ],
  [
    "Nem érzem magam különösebben hibásnak.",
    "Úgy érzem, lehet, hogy rászolgáltam valami büntetésre.",
    "Úgy érzem, hogy rászolgáltam a büntetésre.",
    "Azt akarom, hogy megbüntessenek.",
  ],
  [
    "Nem csalódtam magamban.",
    "Csalódtam magamban.",
    "Nem szeretem magam.",
    "Gyűlölöm magam.",
  ],
  [
    "Nem érzem, hogy rosszabb lennék, mint bárki más.",
    "Gyengeségeim és hibáim miatt erősen bírálom magam.",
    "Mindig vádolom magam a hibáim miatt.",
    "Minden rosszért, ami bekövetkezik, vádolom magam.",
  ],
  [
    "Eszembe sem jut, hogy magamnak ártsak, vagy magam ellen tegyek valamit.",
    "Van öngyilkossággal kapcsolatos gondolatom, de nem tudnám megtenni.",
    "Szeretném megölni magam.",
    "Megölném magam, ha tudnám.",
  ],
  [
    "Nem sírok többet, mint szoktam.",
    "Mostanában többet sírok, mint szoktam.",
    "Mostanában mindig sírok.",
    "Valaha tudtam sírni, most nem tudok, még akkor sem, ha akarnám.",
  ],
  [
    "Nem vagyok ingerlékenyebb, mint máskor.",
    "Könnyebben leszek ingerült, vagy haragos, mint korábban.",
    "Mostanában állandóan ingerült vagyok.",
    "Már nem izgatnak fel olyan dolgok, amik korábban ingerültté tettek.",
  ],
  [
    "Az emberek iránti érdeklődésem nem csökkent.",
    "Kevésbé érdekelnek az emberek most, mint azelőtt.",
    "Jelentősen csökkent mások iránti érdeklődésem.",
    "Minden érdeklődésemet elvesztettem mások iránt.",
  ],
  [
    "Éppen olyan jól döntök, mint korábban.",
    "Mostanában elhalasztom a döntéseimet.",
    "A korábbiakhoz képest igen nehezen döntök.",
    "Semmiben nem tudok dönteni többé.",
  ],
  [
    "Nem érzem, hogy rosszabbul néznék ki, mint máskor.",
    "Félek, hogy öregnek és csúnyának látszom.",
    "Úgy érzem, hogy hátrányomra változtam, és kevésbé vagyok vonzó.",
    "Azt hiszem, csúnya vagyok.",
  ],
  [
    "Éppen olyan jól tudok dolgozni, mint máskor.",
    "Külön erőfeszítésembe kerül, hogy valami munkába belefogjak.",
    "Nagy erőfeszítésre van szükségem ahhoz, hogy megcsináljak valamit is.",
    "Semmi munkát nem vagyok képes ellátni.",
  ],
  [
    "Ugyan olyan jól tudok aludni, mint általában.",
    "Nem alszom olyan jól, mint azelőtt.",
    "A szokottnál 2-3 órával korábban ébredek és nehezen tudok újra elaludni.",
    "Több órával korábban ébredek, mint szoktam és nem tudok újra elaludni.",
  ],
  [
    "Nem fáradok el jobban, mint azelőtt.",
    "Hamarabb elfáradok, mint azelőtt.",
    "Majdnem minden elfáraszt, amit csinálok.",
    "Túlságosan fáradt vagyok, hogy bármit is csináljak.",
  ],
  [
    "Az étvágyam nem rosszabb, mint azelőtt.",
    "Az étvágyam nem olyan jó, mint azelőtt.",
    "Mostanában az étvágyam sokkal rosszabb.",
    "Egyáltalán nincs már étvágyam.",
  ],
  [
    "Semmivel sem vesztettem többet a súlyomból, mint máskor.",
    "Az utóbbi két hónapban többet vesztettem, mint 2 kg.",
    "Az utóbbi két hónapban többet vesztettem, mint 5 kg.",
    "Az utóbbi két hónapban többet vesztettem, mint 8 kg.",
  ],
  [
    "Nem foglalkozom többet egészségi állapotommal, mint azelőtt.",
    "Aggódom olyan testi-fizikai problémák miatt, mint fájdalmak vagy gyomorpanaszok.",
    "Nagyon aggódom testi-fizikai panaszaim miatt és nehéz valami másra is gondolnom.",
    "Annyira aggódom a testi-fizikai panaszok miatt, hogy másra nem tudok gondolni.",
  ],
  [
    "Nem vettem észre lényeges változást szexuális érdeklődésemben.",
    "A szokottnál kevésbé érdeklődöm a szex iránt.",
    "Mostanában jóval kevésbé érdeklődöm a szex iránt.",
    "Teljesen elvesztettem a szex iránti érdeklődésemet.",
  ],
];

const rsStatements = [
  "Sötéten látom a jövőmet.",
  "Sosem fognak úgy alakulni a dolgok, ahogy én akarom.",
  "Fölösleges igazán törni magam valamiért, amit akarok, mert valószínűleg úgysem érem el.",
  "Úgy látom, hogy a jövőm reménytelen és a helyzetem nem fog változni.",
];

const whoItems = [
  "Vidámnak és jókedvűnek érezte magát?",
  "Nyugodtnak és ellazultnak érezte magát?",
  "Aktívnak és élénknek érezte magát?",
  "Ébredéskor frissnek és élénknek érezte magát?",
  "A napjai tele voltak az Ön számára érdekes dolgokkal?",
];

const staiStateItems = [
  "Nyugodtnak érzem magam.",
  "Biztonságban érzem magam.",
  "Feszültnek érzem magam.",
  "Valami bánt.",
  "Gondtalannak érzem magam.",
  "Zaklatott vagyok.",
  "Aggódom, hogy bajba keveredem.",
  "Kipihentnek érzem magam.",
  "Szorongok.",
  "Kellemesen érzem magam.",
  "Elég önbizalmat érzek magamban.",
  "Ideges vagyok.",
  "Nyugtalannak érzem magam.",
  "Fel vagyok húzva.",
  "Minden feszültségtől mentes vagyok.",
  "Elégedett vagyok.",
  "Aggódom.",
  "Túlzottan izgatott és feszült vagyok.",
  "Vidám vagyok.",
  "Jól érzem magam.",
];

const staiTraitItems = [
  "Jól érzem magam.",
  "Gyorsan elfáradok.",
  "A sírás ellen küszködnöm kell.",
  "A szerencse engem elkerül.",
  "Sokszor hátrányos helyzetbe kerülök, mert nem tudom elég gyorsan elhatározni magam.",
  "Kipihentnek érzem magam.",
  "Nyugodt, megfontolt és tettrekész vagyok.",
  "Úgy érzem, hogy annyi megoldatlan problémám van, hogy nem tudok úrrá lenni rajtuk.",
  "A semmiséget is túlzottan a szívemre veszem.",
  "Boldog vagyok.",
  "Hajlamos vagyok túlságosan komolyan venni a dolgokat.",
  "Kevés az önbizalmam.",
  "Biztonságban érzem magam.",
  "A kritikus helyzeteket szívesen kerülöm.",
  "Csüggedtnek érzem magam.",
  "Elégedett vagyok.",
  "Lényegtelen dolgok is sokáig foglalkoztatnak, és nem hagynak nyugodni.",
  "A csalódások annyira megviselnek, hogy nem tudom a fejemből kiverni őket.",
  "Kiegyensúlyozott vagyok.",
  "Feszült lelkiállapotba jutok, és izgatott leszek, ha az utóbbi időszak gondjaira, bajaira gondolok.",
];

const dasItems = [
  "Ha valakit megkritizálnak, nyilvánvaló, hogy elkeseredik.",
  "Legjobb, ha feladom saját érdeklődésemet, hogy elnyerjem mások tetszését.",
  "Mások elismerésére van szükségem, hogy boldognak érezzem magam.",
  "Ha valaki, aki nekem fontos, vár tőlem valamit, biztos megteszem.",
  "Személyes értékem nagyrészt attól függ, hogy mások mit gondolnak rólam.",
  "Nem lehetek boldog, ha nem szeret valaki.",
  "Ha mások nem szeretnek, kevésbé vagyok boldog.",
  "Ha azok az emberek, akikkel törődöm, visszautasítanak, valamit rosszul csinálok.",
  "Ha valaki, akit szeretek, nem szeret, ez azt jelenti, hogy nem vagyok szeretetre méltó.",
  "Másoktól elkülönülten élni boldogtalansághoz vezet.",
  "Ha értékes ember lennék, legalább egy fontos szempontból kiváló lennék.",
  "Hasznos, alkotó, kreatív embernek kell lennem, különben nincs célja az életemnek.",
  "Azok az emberek, akiknek jó ötleteik vannak, értékesebbek, mint akiknek nincs.",
  "Ha nem dolgozom olyan jól, mint mások, kevesebbet érek.",
  "Ha sikertelen vagyok a munkámban, sikertelen ember vagyok.",
  "Ha valamit nem tudok jól megcsinálni, egyáltalán nincs értelme belekezdeni.",
  "Szégyenletes, ha az ember gyengeségét látják mások.",
  "Bármibe, amibe belefog az ember, meg kell próbálni a legjobbnak lenni.",
  "Elkeseredem, ha hibát követek el.",
  "Ha nem állítom magam elé a legmagasabb mércét, másodrendű ember leszek.",
  "Ha meg vagyok győződve arról, hogy jár nekem valami, jogosan várhatom el, hogy meg is kapjam.",
  "Természetes, hogy az ember csalódottnak érzi magát, ha akadályba ütközik, hogy elérje, amit akar.",
  "Ha mások igényeit a magamé elé helyezem, nekik is segíteniük kell.",
  "Ha jó férj vagy jó feleség vagyok, házastársamnak szeretnie kell engem.",
  "Ha valakinek jót teszek, remélhetem, hogy tekintettel lesz rám, és éppen olyan jól fog bánni velem, mint én vele.",
  "Felelős vagyok azért, hogy a hozzám közel állók hogyan érzik magukat és hogyan viselkednek.",
  "Ha megkritizálok valakit és ő haragos vagy elkeseredett lesz, én vagyok az oka.",
  "Ha jó értékes, erkölcsös ember akarok lenni, mindenkinek segítenem kell, akinek szüksége van rá.",
  "Ha egy gyereknek érzelmi vagy viselkedési zavarai vannak, ez arra utal, hogy szülei valamilyen fontos szempontból hibáznak.",
  "Képesnek kell lennem arra, hogy mindenki elégedett legyen velem.",
  "Nem tudok uralkodni az érzelmeimen, ha valami rossz történik velem.",
  "Hiába is próbálnánk elkerülni az elkeseredettség érzését, hiszen az a mindennapi élet szükséges és elkerülhetetlen tartozéka.",
  "Hangulatom elsősorban olyan rajtam kívül álló tényezőktől függ, mint a múltam, hormonciklusok, bioritmusok, véletlen vagy a szerencse.",
  "Boldogságom nagyrészt attól függ, hogy mi történik velem.",
  "Azok az emberek, akiken a szerencse jegyei látszanak (jó megjelenés, jó szociális helyzet, gazdagság, hírnév) boldogabbak, mint mások.",
];

const rsColumns = [
  { value: 0, text: "0 - egyáltalán nem igaz" },
  { value: 1, text: "1 - részben igaz" },
  { value: 2, text: "2 - nagymértékben igaz" },
  { value: 3, text: "3 - teljes mértékben igaz" },
];

const whoColumns = [
  { value: 0, text: "0 - egyáltalán nem jellemző" },
  { value: 1, text: "1 - alig jellemző" },
  { value: 2, text: "2 - jellemző" },
  { value: 3, text: "3 - teljesen jellemző" },
];

const staiColumns = [
  { value: 1, text: "1 - egyáltalán nem" },
  { value: 2, text: "2 - valamennyire" },
  { value: 3, text: "3 - eléggé" },
  { value: 4, text: "4 - nagyon / teljesen" },
];

const dasColumns = [
  { value: 2, text: "2 - teljesen egyetértek" },
  { value: 1, text: "1 - kissé egyetértek" },
  { value: 0, text: "0 - semleges" },
  { value: -1, text: "-1 - kissé nem értek egyet" },
  { value: -2, text: "-2 - egyáltalán nem értek egyet" },
];

export const json = {
  title: "Pszichológiai kérdőívcsomag",
  description: "BDI, RS, WHO WBI-5, STAI-S/STAI-T és DAS kérdőívek SurveyJS formátumban.",
  completedHtml: "<h3>Köszönjük a kitöltést.</h3>",
  showProgressBar: true,
  progressBarLocation: "belowHeader",
  progressBarShowPageTitles: true,
  checkErrorsMode: "onComplete",
  pageNextText: "Tovább",
  pagePrevText: "Vissza",
  completeText: "Befejezés",
  widthMode: "static",
  width: "1000",
  pages: [
    {
      name: "bdi_1",
      title: "BDI I. rész",
      elements: [
        {
          type: "html",
          name: "bdi_intro",
          html: "<div><h4>BDI</h4><p>A kérdőív csoportosított állításokat tartalmaz. Kérjük, gondosan olvasson át minden állításcsoportot. Válassza ki a csoport többi tagja közül azt az egy állítást, amely a legjobban leírja az Ön érzését az elmúlt héttől egészen a mai napig.</p><p>Ha az adott csoportból több állítást is választana, akkor valamennyit jelölje meg. Kérjük, olvassa el valamennyi állítást az adott csoporton belül mielőtt választ.</p></div>",
        },
        ...bdiItems.slice(0, 11).map((statements, index) => createBdiQuestion(index + 1, statements)),
      ],
    },
    {
      name: "bdi_2",
      title: "BDI II. rész",
      elements: [
        ...bdiItems.slice(11).map((statements, index) => createBdiQuestion(index + 12, statements)),
        {
          type: "panel",
          name: "bdi_weight_panel",
          title: "Kiegészítő kérdések a 19. tételhez",
          elements: [
            {
              type: "radiogroup",
              name: "bdi_weight_loss_dieting",
              title: "Kevesebb evéssel tudatosan igyekszem lefogyni.",
              isRequired: true,
              choices: [
                { value: "igen", text: "Igen" },
                { value: "nem", text: "Nem" },
              ],
            },
            {
              type: "text",
              name: "bdi_weight",
              title: "Testsúly",
              inputType: "number",
            },
            {
              type: "text",
              name: "bdi_height",
              title: "Testmagasság",
              inputType: "number",
              startWithNewLine: false,
            },
          ],
        },
      ],
    },
    {
      name: "rs",
      title: "RS - rövidített változat",
      elements: [
        createMatrixQuestion({
          name: "rs_scale",
          title: "Mennyire voltak jellemzőek Önre az alábbi állítások az elmúlt héten, a mai napot is beleértve?",
          description: "0 - egyáltalán nem igaz, 1 - részben igaz, 2 - nagymértékben igaz, 3 - teljes mértékben igaz",
          columns: rsColumns,
          rows: rsStatements,
          rowTitleWidth: "72%",
        }),
      ],
    },
    {
      name: "who_wbi_5",
      title: "WHO WBI-5",
      elements: [
        createMatrixQuestion({
          name: "who_wbi_5",
          title: "Kérjük, karikázza be azt a válaszlehetőséget, mely legjobban leírja, hogyan érezte magát az elmúlt 2 hét során.",
          columns: whoColumns,
          rows: whoItems,
          rowTitleWidth: "62%",
        }),
      ],
    },
    {
      name: "stai_state",
      title: "STAI-S",
      elements: [
        createMatrixQuestion({
          name: "stai_state",
          title: "ÉPPEN MOST HOGYAN ÉRZI MAGÁT",
          description: "Figyelmesen olvassa el valamennyit, és a jelenlegi érzéseit legjobban kifejező választ jelölje meg.",
          columns: staiColumns,
          rows: staiStateItems,
          rowTitleWidth: "62%",
        }),
      ],
    },
    {
      name: "stai_trait",
      title: "STAI-T",
      elements: [
        createMatrixQuestion({
          name: "stai_trait",
          title: "ÁLTALÁBAN HOGYAN ÉRZI MAGÁT",
          columns: staiColumns,
          rows: staiTraitItems,
          rowTitleWidth: "62%",
        }),
      ],
    },
    {
      name: "das_1",
      title: "DAS I. rész",
      elements: [
        createMatrixQuestion({
          name: "das_part_1",
          title: "Diszfunkcionális attitűd skála (1-18)",
          description: "Kérem, írjon +2-től -2-ig egy számjegyet minden állítás mellé.",
          columns: dasColumns,
          rows: dasItems.slice(0, 18),
          rowTitleWidth: "72%",
        }),
      ],
    },
    {
      name: "das_2",
      title: "DAS II. rész",
      elements: [
        createMatrixQuestion({
          name: "das_part_2",
          title: "Diszfunkcionális attitűd skála (19-35)",
          columns: dasColumns,
          rows: dasItems.slice(18),
          rowTitleWidth: "72%",
        }),
      ],
    },
  ],
};